import type {
  GetCartRequest,
  GetCartRewardProductsRequest,
  GetExpectedCreditRequest,
  UpdateCartItemRequest,
} from './types';

export const CART_QUERY_KEYS = {
  default: () => ['cart'] as const,
  carts: () => [...CART_QUERY_KEYS.default(), 'getCart'] as const,
  rewardProducts: () => ['cart', 'rewardProducts'] as const,
  getRewardProducts: ({ currency, sessionKey, actorId }: GetCartRewardProductsRequest, cartSnapshotKey: string) =>
    [...CART_QUERY_KEYS.rewardProducts(), currency, sessionKey, actorId, cartSnapshotKey] as const,
  getCart: ({ currency, sessionKey }: Pick<GetCartRequest, 'currency' | 'sessionKey'>) =>
    [...CART_QUERY_KEYS.carts(), currency, sessionKey] as const,
  addToCart: () => [...CART_QUERY_KEYS.default(), 'addToCart'] as const,
  addItemsToCart: () => [...CART_QUERY_KEYS.default(), 'addItemsToCart'] as const,
  updateCartItem: (params?: UpdateCartItemRequest) => [...CART_QUERY_KEYS.default(), 'updateCartItem', params] as const,
  removeCartItem: () => [...CART_QUERY_KEYS.default(), 'removeCartItem'] as const,
  applyCoupon: () => [...CART_QUERY_KEYS.default(), 'applyCoupon'] as const,
  removeCoupon: () => [...CART_QUERY_KEYS.default(), 'removeCoupon'] as const,
  /** Prefix for every expected-credit preview; cart mutations invalidate this whole family. */
  expectedCredit: () => [...CART_QUERY_KEYS.default(), 'expectedCredit'] as const,
  getExpectedCredit: ({
    currency,
    sessionKey,
    appliedCreditAmount,
  }: GetExpectedCreditRequest & Pick<GetCartRequest, 'sessionKey'>) =>
    [...CART_QUERY_KEYS.expectedCredit(), currency, sessionKey, appliedCreditAmount] as const,
};
